import React from 'react';
import { useSelector } from 'react-redux';
import { googleAvailableSelector } from '../../features/map/mapSlice';


import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import MapIcon from '@mui/icons-material/Map';
import { blue, green } from '@mui/material/colors';

import { mdiGoogle } from '@mdi/js';
import Icon from '@mdi/react';
import { Grid } from '@mui/material';
import { Typography } from 'antd';

import { userSelector } from '../../features/user/UserSlice';

const maptypes = ['roadmap', 'hybrid', 'satellite', 'terrain'];


const useStyles = makeStyles({
    avatar: {
        backgroundColor: blue[700],
        //color: blue[100],
    },
    avatara: {
        backgroundColor: green[700],
        //color: blue[100],
    },
});

const MapTypeModal = ({ onClose, selectedValue, open }) => {
    const classes = useStyles();
    const googleAvailable = useSelector(googleAvailableSelector);

    const handleClose = () => {
        onClose(selectedValue);
    };

    const handleListItemClick = (value) => {
        onClose(value);
    };

    const switchToOsm = () => {
        onClose('osm');
    }
    const thisUser = useSelector(userSelector);
    const {
        googleMapdayConsumed,
        googleMapmonthConsumed, googleMapdayLimit, googleMapmonthLimit,
        hasGoogleAccess
    } = thisUser;

    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
            <DialogTitle id="simple-dialog-title">Choose Your Map</DialogTitle>
            <Grid container direction="row" spacing={3}>
                <Grid item sm={6}>
                    <List>
                        {googleAvailable && maptypes.map((maptype) => (
                            <ListItem button onClick={() => handleListItemClick(maptype)} key={maptype}>
                                <ListItemAvatar>
                                    <Avatar className={classes.avatar}>
                                        <Icon
                                            path={mdiGoogle}
                                            title="Refresh"
                                            size={0.8}
                                            color="White"
                                        />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={`Google ${toTitleCase(maptype)}`} />
                            </ListItem>
                        ))}
                        <ListItem button onClick={() => switchToOsm()}>
                            <ListItemAvatar>
                                <Avatar className={classes.avatara}>
                                    <MapIcon />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary="Openstreet Map" />
                        </ListItem>
                        {
                            (!googleAvailable || hasGoogleAccess === 0) &&
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar className={classes.avatarb}>
                                        <Icon
                                            path={mdiGoogle}
                                            title="Refresh"
                                            size={0.8}
                                            color="White"
                                        />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={`Google Not Available`} />
                            </ListItem>
                        }

                    </List>
                </Grid>
                <Grid item sm={6}>
                    {
                        hasGoogleAccess === 1 &&
                        <div style={{ margin: '20px' }}>
                            <Grid container direction="column" spacing={1}>
                                <Grid item container direction="row">
                                    <Grid item sm={12}><Typography variant="body1" color="textSecondary"><span style={{ color: 'royalblue' }}><b>Google Map Usage</b></span></Typography></Grid>
                                </Grid>
                                <Grid item container direction="row">
                                    <Grid item sm={12}>
                                        <b>Today</b>
                                        <span style={{ color: 'red' }}>
                                            {googleMapdayLimit && googleMapdayConsumed >= googleMapdayLimit && " (Limit Exhausted)"}
                                        </span>
                                    </Grid>
                                    <Grid item sm={8}>Used</Grid>
                                    <Grid item sm={4}>{googleMapdayConsumed} </Grid>
                                    <Grid item sm={8}>Daily Limit</Grid>
                                    <Grid item sm={4}>{googleMapdayLimit || 'Unlimited'} </Grid>
                                </Grid>
                                <Grid item container direction="row">
                                    <Grid item sm={12}>
                                        <b>This Month</b>
                                        <span style={{ color: 'red' }}>
                                            {googleMapmonthLimit && googleMapmonthConsumed >= googleMapmonthLimit && " (Limit Exhausted)"}
                                        </span>
                                    </Grid>
                                    <Grid item sm={8}>Used</Grid>
                                    <Grid item sm={4}>{googleMapmonthConsumed} </Grid>
                                    <Grid item sm={8}>Monthly Limit</Grid>
                                    <Grid item sm={4}>{googleMapmonthLimit || 'Unlimited'} </Grid>
                                </Grid>
                            </Grid>
                        </div>
                    }
                    {!googleAvailable &&
                        <div style={{ margin: '20px' }}>
                            <Grid container direction="column" spacing={1}>
                                <Grid item sm={12} style={{ backgroundColor: 'Ivory', border: "1px solid grey", }}>
                                    <Typography variant="h6">
                                        <b>Get Google Maps</b> (<span style={{ color: 'dodgerblue' }}>Recommended</span>)
                                    </Typography>
                                    <Typography variant="body1" color="textPrimary">
                                        Up to 28,000 free map loads per month
                                    </Typography>
                                    <br />
                                    <Typography variant="body1">
                                        <b><a href="https://mapsplatform.google.com/">Get your own Google Maps key,</a></b> and we will add it to your account
                                    </Typography>
                                    <br />
                                    <br />
                                </Grid>
                            </Grid>
                        </div>
                    }

                </Grid>
            </Grid>



        </Dialog>
    );
}

export default MapTypeModal;

function toTitleCase(str) {
    return str.replace(
        /\w\S*/g,
        function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );
}